var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"toggle-switch"},[_c('input',{attrs:{"type":"radio","name":_vm.name,"id":_vm.getId()},domProps:{"checked":_vm.active},on:{"click":_vm.onClick}}),_c('label',{attrs:{"for":_vm.getId()}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }